export enum AppMode {
    myiaMy = 'myiaMy',
    myiaModerator = 'myiaModerator'
}
